import { connect } from 'react-redux';
import MessageRadar from './MessageRadar';

const mapStateToProps = () => ({
  // draft: state.draft,
  // currentUser: state.currentUser,
  // friendsQuantity: state.friends.length(),
});

// const mapDispachToProps = (dispatch) => ({
//   onDraftSend: (currentUserId) => dispatch(sendDraft(currentUserId)),
// });

export default connect(mapStateToProps)(MessageRadar);
